const API_BASE_URL = process.env.VUE_APP_API_URL ;

// Fonction pour effectuer des appels API avec fetch
async function apiFetch(endpoint, options = {}) {
  const token = localStorage.getItem('token');

  // Ajouter le token JWT dans les en-têtes
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    if (response.status === 401) {
      console.error('Session expirée. Redirection vers la connexion.');
      localStorage.removeItem('token');
      window.location.href = '/login'; // Redirection vers la page de connexion
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Erreur lors de l\'appel API');
  }

  return response.json();
}

export default apiFetch;

export const companyApi = {
  getMine: () => apiFetch('/companies/mine'),
  getDepartments: (companyId) => apiFetch(`/companies/${companyId}/departments`),
  createDepartment: (companyId, payload) => apiFetch(`/companies/${companyId}/departments`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),
  updateDepartment: (companyId, deptId, payload) => apiFetch(`/companies/${companyId}/departments/${deptId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  }),
  deleteDepartment: (companyId, deptId) => apiFetch(`/companies/${companyId}/departments/${deptId}`, {
    method: 'DELETE',
  }),
  getBadges: (companyId) => apiFetch(`/companies/${companyId}/badges`),
  getAvailableBadges: (companyId) => apiFetch(`/companies/${companyId}/badges/available`),
  createBadge: (companyId, payload) => apiFetch(`/companies/${companyId}/badges`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),
  updateBadge: (companyId, badgeId, payload) => apiFetch(`/companies/${companyId}/badges/${badgeId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  }),
  deleteBadge: (companyId, badgeId) => apiFetch(`/companies/${companyId}/badges/${badgeId}`, {
    method: 'DELETE',
  }),
  getVisitedPeople: (companyId) => apiFetch(`/companies/${companyId}/visited-people`),
  createVisitedPerson: (companyId, payload) => apiFetch(`/companies/${companyId}/visited-people`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }),
  updateVisitedPerson: (companyId, personId, payload) => apiFetch(`/companies/${companyId}/visited-people/${personId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  }),
  deleteVisitedPerson: (companyId, personId) => apiFetch(`/companies/${companyId}/visited-people/${personId}`, {
    method: 'DELETE',
  }),
};